import routerOptions0 from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/node_modules/.pnpm/nuxt@3.17.2_@parcel+watcher@2.5.1_@types+node@20.12.7_db0@0.3.4_eslint@8.57.0_ioredis@5_0f2589a32ad9c4c27a35c81f5a3b4316/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}